/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum CurrencyTypeOfPay {
    BASE = 'base',
    ACTUAL_BONUS = 'actualBonus',
    TARGET_BONUS = 'targetBonus',
    TARGET_TOTAL_CASH = 'targetTotalCash',
    ACTUAL_TOTAL_CASH = 'actualTotalCash',
    TARGET_TOTAL_DIRECT = 'targetTotalDirect',
    ACTUAL_TOTAL_DIRECT = 'actualTotalDirect',
    LTI_ACTUAL = 'ltiActual',
    FIXED_COMP = 'fixedComp',
    TOTAL_ALLOWANCES = 'totalAllowances',
    LTI_TARGET = 'ltiTarget',
    LTI_NEW_HIRE_ACTUAL = 'ltiNewHireActual',
    LTI_NEW_HIRE_TARGET = 'ltiNewHireTarget',
    SALES_INCENTIVE_ACTUAL = 'salesIncentiveActual',
    SALES_INCENTIVE_TARGET = 'salesIncentiveTarget',
    SALES_COMMISSION_PAID_ACTUAL = 'salesCommissionPaidActual',
    ANNUAL_BASE = 'annualBase',
    TRANSPORTATION_ALLOWANCE = 'transportationAllowance',
    HOUSING_ALLOWANCE = 'housingAllowance',
    MEAL_ALLOWANCE = 'mealAllowance',
    EDUCATION_ALLOWANCE = 'educationAllowance',
    JOB_SKILL_ALLOWANCE = 'jobSkillAllowance',
    LANGUAGE_ALLOWANCE = 'languageAllowance',
    LEAVE_TRAVEL_ALLOWANCE = 'leaveTravelAllowance',
    TELECOMMUNICATION_PHONE_ALLOWANCE = 'telecommunicationPhoneAllowance',
    CAR_ALLOWANCE = 'carAllowance',
}
